module.exports = __webpack_public_path__ + "img/7_34ce3f523.png";